import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getSharingDetailsPopup} from "../../../../../../../../../../../../../../../../../actions/sharingDetailsActions";
import {guidedTours as setGuidedTours} from "../../../../../../../../../../../../../../../../../actions/guidedToursActions";
import {targetedContact} from "../../../../../../../../../../../../../../../../../actions/contactActions";
import Button from '../../../../../../../../../../../../../../../../components/button';

function ShareContactButton ({contactId, contactName, contactType, disabled, title}) {

	const findLabels = useSelector(state => state.contactsGroupItemReducer.findLabels);
	const profile = useSelector(state => state.profileReducer.getProfile);

	const dispatch = useDispatch();

	if (profile && profile.role === 'RESTRICTED_USER') {
		return null;
	}

    const clickHandler = (e) => {
        e.stopPropagation();
        if(findLabels.contactsGroups.length > 0){

	        dispatch(getSharingDetailsPopup([true, "select_one_label", [{
				'id': e.currentTarget.dataset.contactId,
				'type' : e.currentTarget.dataset.contactType
			}], e.currentTarget.dataset.contactName, true]));

        } else {

            /*this.props.msgBar(['error', 'You need first to create a label.']);*/

	        if(document.getElementById('t1')){
		        document.getElementById('t1').style.transform = "scale(0)";
	        }

	        setTimeout(() => {
		        dispatch(setGuidedTours({
			        "t2" : true,
		        }));
	        },500);

	        dispatch(targetedContact({
                id: e.currentTarget.dataset.contactId,
                name: e.currentTarget.dataset.contactName,
                type: e.currentTarget.dataset.contactType
            }));

            dispatch(getSharingDetailsPopup([true, "add_user", e.currentTarget.dataset.contactId, e.currentTarget.dataset.contactName, e.currentTarget.dataset.contactType]));
        }
	};


	return (
		<Button
			className="btn-link"
			title={title || ''}
			data-contact-id={contactId}
			data-contact-name={contactName}
			data-contact-type={contactType}
			onClick={ clickHandler }
			disabled={disabled}
		>
			<div className="more-option-item__picto">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<line
						fill="none"
						stroke="currentColor"
						strokeWidth={2}
						strokeMiterlimit={10}
						x1={7.962}
						y1={13.64}
						x2={16.038}
						y2={17.678}
					/>
					<line
						fill="none"
						stroke="currentColor"
						strokeWidth={2}
						strokeMiterlimit={10}
						x1={7.962}
						y1={10.36}
						x2={16.038}
						y2={6.321}
					/>
					<path
						fill="none"
						strokeWidth={2}
						strokeMiterlimit={10}
						d="M 22.979 4.682 C 22.979 6.7 21.339 8.339 19.32 8.339 C 17.301 8.339 15.659 6.7 15.659 4.682 C 15.659 2.661 17.301 1.021 19.32 1.021 C 21.339 1.021 22.979 2.661 22.979 4.682"
						stroke="currentColor"
					/>
					<path
						fill="none"
						stroke="currentColor"
						strokeWidth={2}
						strokeMiterlimit={10}
						d="M 22.979 19.32 C 22.979 21.339 21.339 22.979 19.32 22.979 C 17.301 22.979 15.659 21.339 15.659 19.32 C 15.659 17.301 17.301 15.659 19.32 15.659 C 21.339 15.659 22.979 17.301 22.979 19.32"
					/>
					<path
						fill="none"
						strokeWidth={2}
						strokeMiterlimit={10}
						d="M 8.339 12 C 8.339 14.018 6.7 15.659 4.682 15.659 C 2.661 15.659 1.021 14.018 1.021 12 C 1.021 9.982 2.661 8.339 4.682 8.339 C 6.699 8.339 8.339 9.982 8.339 12"
						stroke="currentColor"
					/>
				</svg>
			</div>
			<div className="more-option-item__text">
				<span>{title}</span>
			</div>
		</Button>
	)

}

export default ShareContactButton;
